<div class="table-wrapper" (scroll)="sessionListDataSource.onScroll($event)">
  @if (sessionListDataSource) {
    <table
      mat-table
      [dataSource]="dataSource()"
      fixedLayout="true"
      class="main-table"
      #tableContainer
      >
      <!-- Affordance Column -->
      <ng-container matColumnDef="affordance">
        <th mat-header-cell *matHeaderCellDef>
          <span class="accessibility-text" translate="common_unviewed-submissions"></span>
        </th>
        <td mat-cell *matCellDef="let session">
          @if (shouldShowSelectionCheckbox(session)) {
            <mat-checkbox
              class="submit-selection-checkbox"
              color="primary"
              [checked]="isSessionSelected(session)"
              [disabled]="isSubmittingSessions"
              [tabindex]="(!allowSelection || isSubmittingSessions) ? -1 : 0"
              [aria-label]="'activity-task-sessions_submit-checkbox-aria-label' | translate"
              (click)="$event.stopPropagation()"
              (change)="onSubmitCheckboxChange(session, $event)">
            </mat-checkbox>
          } @else {
            <dot-indicator
              [session]="session"
              [color]="(session.isLive()) ? 'red' : 'green'">
            </dot-indicator>
          }
        </td>
      </ng-container>
      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          <span translate="common_name"></span>
        </th>
        <td mat-cell *matCellDef="let session" [matTooltip]="session.description">
          <span class="flex">
            @if (session.isRecorded()) {
              @if (!ngxSessionService.getMedia(session)) {
                <div class="media-thumbnail pending-thumbnail">
                  @if (selectedService.getActivity().isConversationBoard()) {
                    <span>
                      <img class="logo not-loading"
                        [alt]="spotLogo.alt"
                        [src]="spotLogo.src"/>
                    </span>
                  } @else {
                    <loading [width]="'18px'" [height]="'18px'"></loading>
                  }
                </div>
              } @else {
                @if (ngxSessionService.getMedia(session).isReady()) {
                  <thumbnail
                    data-cy="media-ready"
                    [src]="ngxSessionService.getMedia(session).thumbnail_url"
                    [duration]="ngxSessionService.getMedia(session).duration"
                    [fallbackIcon]="'ficon-app-camcorder'"
                    class="media-thumbnail recorded-thumbnail {{FirstCommentTourClasses.sessionTablePulse}}"
                    >
                  </thumbnail>
                }
                @if (ngxSessionService.getMedia(session).isPending()) {
                  <div class="media-thumbnail pending-thumbnail" data-cy="session-pending">
                    <loading [width]="'18px'" [height]="'18px'"></loading>
                  </div>
                }
                @if (ngxSessionService.getMedia(session).isFailed()) {
                  <div class="media-thumbnail failed-thumbnail">
                    <i class="ficon-app-warning-circle-outline"></i>
                  </div>
                }
              }
            }
            @if (!session.isRecorded()) {
              @if (ngxSessionService.shouldDisplayJoinButton(session)) {
                <div class="media-thumbnail live-thumbnail">
                  <span>{{'session-join' | translate}}</span>
                </div>
              }
            }
            <span class="description" data-cy="session-description">{{ session.description }}</span>
            @if (!session.description?.length) {
              <span>&#8212;</span>
            }
          </span>
        </td>
      </ng-container>
      <!-- Participants Column -->
      <ng-container matColumnDef="participants">
        <th mat-header-cell *matHeaderCellDef>
          <span translate="participants"></span>
        </th>
        <td mat-cell *matCellDef="let session" [matTooltip]="session.getFormattedPresenters()">
          <ellipsis-with-count [nameList]="session.getPresenterNames()"></ellipsis-with-count>
          @if (!session.getPresenterNames().length) {
            <span>
              @if (selectedService.getActivity().isConversationBoard()) {
                <span
                  class="group-discussion"
                  translate="filter-presenter-names_group">
                </span>
              } @else {
                —
              }
            </span>
          }
        </td>
      </ng-container>
      <!-- Comments Column -->
      <ng-container matColumnDef="comments">
        <th mat-header-cell *matHeaderCellDef>
          <span translate="comments"></span>
        </th>
        <td mat-cell *matCellDef="let session">
          @if (session.num_comments) {
            <span class="comment">
              <span><i class="ficon-app-comment-outline"></i></span>
              <span>{{session.num_comments}}</span>
            </span>
          }
          @if (!session.num_comments) {
            <span class="comment">—</span>
          }
        </td>
      </ng-container>
      <!-- Score Column -->
      @if (shouldDisplayScoreColumn() && {
        isScoreEnabled: this.selectedService.getActivity().isScoreEnabled(),
        totalPoints: this.selectedService.getActivity().getTotalPoints()
        }; as data) {
        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef [hidden]="!data.isScoreEnabled">
            <span translate="common_score"></span>
          </th>
          <td mat-cell *matCellDef="let session" [hidden]="!data.isScoreEnabled">
            @if (ngxSessionService.shouldDisplayScore(session)) {
              @if (session.isScoreAssigned()) {
                <span class="score">{{session.score}} / {{data.totalPoints}}</span>
              }
              @if (!session.isScoreAssigned()) {
                <span class="unscored" translate="common_unscored"></span>
              }
            }
          </td>
        </ng-container>
      }
      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          <span translate="session-list_status"></span>
        </th>
        <td mat-cell *matCellDef="let session">
          <!-- Recorded information -->
          @if (session.isRecorded()) {
            <div>
              @if (!ngxSessionService.getMedia(session)) {
                <span class="pending-text italic">
                  @if (selectedService.getActivity().isConversationBoard()) {
                    <span>—</span>
                  } @else {
                    <span translate="single-attempt-activity_no-recording" data-cy="allow-retake-link"></span>
                  }
                </span>
              } @else {
                @if (ngxSessionService.getMedia(session).isReady()) {
                  <ng-container>
                    @if (session.isPosted() && shouldDisplaySubmissionDate(session)) {
                      <span class="date-posted" [ngClass]="{'red': isSubmittedLate(session)}">
                        @if (isSubmittedLate(session)) {
                          <span class="ficon-app-warning-circle-outline warning-icon red"
                            [matTooltip]="'session-list_submission_late' | translate"
                            matTooltipPosition="above"
                            tabindex="0">
                          </span>
                        }
                        {{ "session-date-posted" | translate: {
                        "date": session.posted_at | date,
                        "time": session.posted_at | date:'shortTime'
                      }
                      }}
                    </span>
                  } @else {
                    <span class="session-date-created" translate="session-date-created-label">
                      <span>
                        {{ "session-date-created" | translate: {
                        "date": session.created_at | date,
                        "time": session.created_at | date:'shortTime'
                      }
                      }}
                    </span>
                  </span>
                }
              </ng-container>
            }
            @if (ngxSessionService.getMedia(session).isPending()) {
              <span
                tabindex="0"
                class="pending-text italic"
                [matTooltip]="'session-card_processing' | translate"
                translate="common_processing_processing"
                data-cy="processing-text">
              </span>
            }
            @if (ngxSessionService.getMedia(session).isFailed()) {
              <span class="failed-text red-text" translate="common_processing_failed"></span>
            }
          }
        </div>
      }
      <!-- Live information -->
      @if (!session.isRecorded()) {
        <div>
          @if (session.isAwaitingStart()) {
            <span class="awaiting-text italic" translate="common_processing_awaiting-start"></span>
          }
          @if (session.isLive()) {
            <span class="is-live-text red-text" translate="common_processing_in-progress"></span>
          }
        </div>
      }
    </td>
  </ng-container>
  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>
      <span class="accessibility-text" translate="session-list_video-actions"></span>
    </th>
    <td mat-cell *matCellDef="let session" (click)="$event.stopPropagation();" (keyup.enter)="$event.stopPropagation()">
      <span class="actions">
        @if (ngxSessionService.hasVideoSharePermission(session) && session.isPosted()) {
          <button
            class="manage-video-share-btn icon-btn ficon-app-share"
            data-cy="share-button"
            type="button"
            [matTooltip]="'common_share' | translate "
            (click)="shareSession(session)">
          </button>
        }
        @if (ngxSessionService.shouldDisplayOptionsMenu(session)) {
          <button
            class="dropdown-menu-btn ficon-app-dots-vertical icon-btn"
            data-cy="session-dropdown-menu"
            type="button"
            [attr.aria-label]="'session-list-item_view-options' | translate"
            (click)="openMenu($event, session)">
          </button>
        }
      </span>
    </td>
  </ng-container>
  <tr
    mat-header-row
    *matHeaderRowDef="displayColumns"
  ></tr>
  <tr
    class="{{FirstCommentTourClasses.sessionTableComplete}}"
    mat-row
    tabindex="0"
    [ngClass]="{ 'viewed': !unviewedState(session) }"
    [attr.aria-label]="session.description"
    *matRowDef="let session; columns: displayColumns"
    (contextmenu)="openMenu($event, session)"
    (keyup.enter)="handleRowInteraction(session, $event)"
    data-cy="session-row-or-card"
  (click)="handleRowInteraction(session, $event)"></tr>
</table>
}

<menu>
  <session-menu
    [session]="selectedSession"
    >
  </session-menu>
</menu>

</div>
